import { servObj } from './init_glob.js';

const formatNumber = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const cart = [];
servObj.cart = cart;

let candidateForDeleteIndex;

const deleteFromCartEvent = (e) => {
    document.querySelector('#confirm-delete-cart-modal').classList.add('show');
    candidateForDeleteIndex = Number(e.target.dataset.index);
};
const deleteFromCart = (index) => {
    if (!index && index !== 0 && index !== '0') return;
    servObj.cart.splice(index, 1);
    updateCart();
};

export const updateCart = () => {
    //console.log("updateCart")
    const modalCart = document.querySelector('.modal_cart');
    const cartWrapper = modalCart.querySelector('#cart-wrapper');
    const countGoodsList = document.querySelectorAll('.count_goods');
    const placeOrderBtn = document.querySelector('#cart__place-order');
    const cart = servObj.cart;

    // Обновляем счётчик товаров
    const cartIsEmpty = cart.length === 0;

    countGoodsList?.forEach((countGoods) => {
        countGoods.style.display = cartIsEmpty ? 'none' : 'flex';
        countGoods.innerText = cart.length;
    });

    if (cartIsEmpty) {
        cartWrapper.innerHTML = '<p>В вашей корзине пока нет товаров</p>';
        placeOrderBtn.classList.add('hide');
        document.querySelector('.order-total__value').innerHTML = '0 &#8381;';
        return;
    }
    placeOrderBtn.classList.remove('hide');

    // Стартовая разметка таблицы
    const cartTable = document.createElement('table');
    cartTable.className = 'cart__table';
    cartTable.innerHTML = `
        <thead>
            <tr>
                <th class="table__number">№</th>
                <th class="table__name">Наименование</th>
                <th class="table__count">К-во</th>
                <th class="table__price">Стоимость</th>
                <th class="table__delete"></th>
            </tr>
        </thead>
        <tbody></tbody>
    `;

    const tbody = cartTable.querySelector('tbody');
    let totalPrice = 0;

    cart.forEach((el, i) => {
        const row = document.createElement('tr');
        row.innerHTML = `
            <td>${i + 1}</td>
            <td>${el.name}</td>
            <td class="td__count">${el.count}</td>
            <td class="td__price">${formatNumber(el.price)}</td>
            <td>
                <button
                    type="button"
                    class="btn_delete modal_opener"
                    data-modal-target="confirm-delete-cart-modal"
                >
                    <img src="./images/icons/delete.svg" alt="Удалить" data-index="${i}" />
                </button>
            </td>
        `;
        tbody.appendChild(row);
        totalPrice += Number(el.price);
    });

    // Вставляем таблицу в DOM
    cartWrapper.innerHTML = '';
    cartWrapper.appendChild(cartTable);

    // Назначаем обработчики удаления
    cartTable
        .querySelectorAll('img[data-index]')
        .forEach((img) => img.addEventListener('pointerdown', deleteFromCartEvent));

    // Обновляем общую сумму
    document.querySelector('.order-total__value').innerHTML = `${formatNumber(totalPrice)} &#8381;`;
};
updateCart();

export const addToCart = (name, price, count, imagePath) => {
    //console.log("addToCart")
    const existing = servObj.cart.find((item) => item.name === name);
    if (existing) {
        existing.count += count;
        existing.price += price;
    } else {
        servObj.cart.push({ name, price, count, imagePath });
    }
    updateCart();
};

document.querySelector('#delete-cart').addEventListener('pointerdown', () => deleteFromCart(candidateForDeleteIndex));
